import React from 'react';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import RoomUtilizationIcon from '../../../16pxIcons/RoomUtilizationIcon';
import BarGraph from '../../../../graphs/BarGraph';
import { DateRange } from '../../../../redux/dateRangeSlice';
import LineGraph from '../../../../graphs/LineGraph';
import Colors from '../../../../constants/Colors';
import { ChartDataPoint } from '../../../../graphs/axisUtils';
import { getRangeHours } from '../../../../constants/Utils';

interface AverageUtilizationGraphProps {
  chartData: ChartDataPoint[],
  comparisonData: ChartDataPoint[],
}

const RoomUtilisationGraph = ({
  chartData, comparisonData,
}: AverageUtilizationGraphProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const compareRange: DateRange = useSelector((state:
    { dateComparisonRange: DateRange }) => (state.dateComparisonRange));
  const showBarGraph: boolean = !(!!compareRange.start && !!compareRange.end)
    && getRangeHours(range) / 24 < 8;
  const cleanedData: ChartDataPoint[] = chartData
    ?.filter((point: ChartDataPoint) => point.value >= 0);
  let count: number = (cleanedData
    ?.reduce((total: number, point: ChartDataPoint) => total + point.value, 0) ?? 0)
    / (cleanedData?.length ?? 0);
  if (!Number.isFinite(count)) count = null;
  else count = Math.floor(count);
  const unit: string = '%';

  return <SpaceUtilizationWidget
    icon={<RoomUtilizationIcon />}
    title='Room utilisation'
    // contentTitles={['GRAPH', 'INSIGHTS']}
    label='Average utilisation'
    {...{ count, unit }}
    content={showBarGraph ? <BarGraph
      title='Average utilisation'
      selectedColor={Colors.light.hereworksDarkBlue200}
      chartHeight={315}
      horizontalTickCount={12}
      style={styles.barGraph}
      {...{ range, chartData, unit }}
    /> : <LineGraph
      title='Average utilisation'
      noTitle
      chartHeight={420}
      horizontalTickCount={7}
      style={styles.lineGraph}
      hideTimeOnTooltip
      {...{
        range, chartData, comparisonData, unit,
      }}
    />}
  />;
};

const styles = StyleSheet.create({
  barGraph: {
    marginStart: -12,
  },
  lineGraph: {
    marginTop: -70,
    marginStart: -24,
    marginEnd: 20,
    marginBottom: -16,
  },
});

export default RoomUtilisationGraph;
